<template>
    <UPopover
        v-model:open="open"
        :default-open="defaultOpen"
        :dismissible="false"
    >
        <UInputDate
            v-model="internalModel"
            class="h-[28px]"
            variant="ghost"
            :min-value="minDate"
            @keydown.esc="finishedEdit"
            @keydown.enter="finishedEdit"
            @keydown.page-up.prevent="pageUp"
            @keydown.page-down.prevent="pageDown"
        >
            <template #trailing>
                <UButton
                    color="neutral"
                    variant="link"
                    size="sm"
                    icon="i-ph-calendar"
                    aria-label="Velg dato"
                    class="px-0"
                />
            </template>
        </UInputDate>
        <template #content>
            <UCalendar
                v-model="internalModel"
                v-on-click-outside="finishedEdit"
                class="p-2"
                initial-focus
                @blur="finishedEdit"
                @update:model-value="finishedEdit"
                @keydown.esc="finishedEdit"
            />
        </template>
    </UPopover>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import {vOnClickOutside} from '@vueuse/components'
import {CalendarDate} from '@internationalized/date'

const modelValue = defineModel<Date>({required: true})
const minDate = new CalendarDate(2020, 1, 1)

const props = defineProps({
    defaultOpen: {
        type: Boolean,
        default: false
    },

})

const open = ref(props.defaultOpen)
const emit = defineEmits(['finished-edit'])
// Convert to and from modelValue of standard date
const internalModel = computed<CalendarDate>({
    get: () => {
        return new CalendarDate(
            modelValue.value.getFullYear(),
            modelValue.value.getMonth() + 1,
            modelValue.value.getDate()
        )
    },
    set: (val: CalendarDate) => {
        if (!val) return
        modelValue.value = val.toDate('utc')
    }
})

const pageUp = () => {
    internalModel.value = internalModel.value.subtract({months: 1})
}

const pageDown = () => {
    internalModel.value = internalModel.value.add({months: 1})
}

const finishedEdit = () => {
    open.value = false
    emit('finished-edit')
}


</script>

<style scoped>

</style>